// skipcq: JS-W1028, JS-0128
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Container, Tab, Tabs } from '@mui/material';
import StickyButtonBar from '../../components/common/StickyButtonBar';
import BreweryBackButton from '../brewery/BreweryBackButton';
import EventFeaturedBeersPanel from './EventFeaturedBeersPanel';
import { EventDetailHero } from './EventDetailPageSections';

/**
 * Inner column for event detail chrome (back, tabs, tab bodies).
 */
function EventDetailShellColumn({
  activeDetailTab,
  centerBlock = null,
  editDisabled,
  featuredBeerIds = [],
  handleAfterFeaturedBeersRemoved,
  handleDetailTabChange,
  handleOpenEdit,
  heroUrl,
  loadError,
  loadingDoc,
  mergedEvent,
  removeFeaturedBeersFromEvent,
  goBackToEvents,
}) {
  const showTabsSection =
    !loadingDoc && !loadError && Boolean(mergedEvent?.id);
  const mainColumnStates =
    loadingDoc || loadError || !mergedEvent?.id;
  const featuredBeerCount = featuredBeerIds.length;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          mb: 1,
        }}
      >
        <BreweryBackButton
          handleBackNavigation={goBackToEvents}
          label="Back to events"
        />
      </Box>
      {showTabsSection ? (
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
            mb: 2,
          }}
        >
          <Tabs
            value={activeDetailTab}
            onChange={handleDetailTabChange}
            aria-label="Event sections"
          >
            <Tab label="Event Details" id="event-detail-tab-0" />
            <Tab
              label={`Featured Beer (${featuredBeerCount})`}
              id="event-detail-tab-1"
            />
          </Tabs>
        </Box>
      ) : null}
      {mainColumnStates ? (
        <Container maxWidth="sm">
          <Box sx={{ py: 3 }}>{centerBlock}</Box>
        </Container>
      ) : activeDetailTab === 0 ? (
        <>
          <StickyButtonBar>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenEdit}
              disabled={editDisabled}
              sx={{ mr: 1 }}
              aria-label="Edit event details"
            >
              Edit
            </Button>
          </StickyButtonBar>
          <Container maxWidth="sm">
            <EventDetailHero
              imageUrl={heroUrl}
              eventTitle={mergedEvent?.name}
            />
            <Box sx={{ py: 3 }}>{centerBlock}</Box>
          </Container>
        </>
      ) : (
        <EventFeaturedBeersPanel
          eventId={mergedEvent.id}
          featuredBeerIds={featuredBeerIds}
          removeFeaturedBeersFromEvent={removeFeaturedBeersFromEvent}
          onAfterBeerRemoved={handleAfterFeaturedBeersRemoved}
        />
      )}
    </>
  );
}

EventDetailShellColumn.propTypes = {
  activeDetailTab: PropTypes.number.isRequired,
  centerBlock: PropTypes.node,
  editDisabled: PropTypes.bool.isRequired,
  featuredBeerIds: PropTypes.arrayOf(PropTypes.string),
  handleAfterFeaturedBeersRemoved: PropTypes.func.isRequired,
  handleDetailTabChange: PropTypes.func.isRequired,
  handleOpenEdit: PropTypes.func.isRequired,
  heroUrl: PropTypes.string,
  loadError: PropTypes.string,
  loadingDoc: PropTypes.bool.isRequired,
  mergedEvent: PropTypes.object,
  removeFeaturedBeersFromEvent: PropTypes.func.isRequired,
  goBackToEvents: PropTypes.func.isRequired,
};

export default EventDetailShellColumn;
